import Input from 'client/components/core/Sidebar/components/Settings/components/Input'
import PropTypes from 'prop-types'
import React from 'react'

const Width = ({ width = 0, update }) => (
  <Input
    update={update}
    value={+width}
    placeholder={'PX'}
    labelText="width"
    type="number"
  />
)

Width.propTypes = {
  update: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Width
